import React from 'react';
import { useTranslation } from 'react-i18next';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { SizeAttributeLabel } from '../shared/SizeAttributeLabel';
import styles from './SizeAttributeDropdownItem.module.scss';

export const SizeAttributeDropdownItem = ({ hasPreview, ...choice }: Props) => {

    const { t } = useTranslation();

    if (!hasPreview) {
        return <SizeAttributeLabel {...choice} />;
    }

    return (
        <>
            {choice.options?.assetUrl ? (
                <img
                    className={styles.preview}
                    src={choice.options.assetUrl}
                    alt={t(choice.label)} />
            ) : (
                <div className={styles.preview} />
            )}
            <SizeAttributeLabel {...choice} />
        </>
    );
};

type Props = SizeChoice & {
    hasPreview: boolean;
};